import { Navigate, useNavigate } from 'react-router-dom'
import { MustChangePasswordForm } from '../components/auth/MustChangePasswordForm'
import { AuthLayout } from '../layouts/AuthLayout'
import { Card } from '../components/ui/Card'
import { useAuth } from '../context/AuthContext'

/**
 * Optional route for bookmarks. Forced password change uses the dashboard modal;
 * this page shows the same form when mustChangePassword is set.
 */
export default function ChangePassword() {
  const navigate = useNavigate()
  const { isAuthenticated, user } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (user?.mustChangePassword) {
    return (
      <AuthLayout>
        <Card accent className="w-full max-w-md shadow-[var(--shadow-modal)]">
          <MustChangePasswordForm onSuccess={() => navigate('/', { replace: true })} />
        </Card>
      </AuthLayout>
    )
  }

  return <Navigate to="/" replace />
}
